// Every sidebar menu item, in its default order. `to` is the item's key for renaming, reordering and hiding.
export const MAIN_MENU = [
  { to: "/", label: "Dashboard" },
  { to: "/leads", label: "Leads" },
  { to: "/bad-leads", label: "Bad Leads / Returns" },
  { to: "/downloads", label: "Downloads" },
  { to: "/replacement-vouchers", label: "Replacement Vouchers" },
  { to: "/postbacks", label: "Postbacks" },
  { to: "/clients", label: "Clients" },
  { to: "/affiliates", label: "Affiliates" },
  { to: "/admin/landing-pages", label: "Landing Pages" },
  { to: "/admin/requests", label: "Request Inbox" },
  { to: "/admin/lead-rescue", label: "Lead Rescue" },
  { to: "/results", label: "Traffic Results" },
  { to: "/admin/onboarding", label: "Buyer Onboarding" },
  { to: "/admin/demand-map", label: "Demand Map" },
  { to: "/admin/traffic-access", label: "Traffic Access" },
  { to: "/admin/test-leads", label: "Test Leads" },
  { to: "/admin/call-taps", label: "Call Taps" },
  { to: "/admin/google-analytics", label: "Google Analytics" },
  { to: "/admin/pixels", label: "Marketing Pixels" },
  { to: "/media-buyer/custom-tracking", label: "Custom Tracking" },
  { to: "/admin/tracking-approvals", label: "Tracking Approvals" },
  { to: "/admin/postbacks", label: "Postback Approvals" },
  { to: "/admin/marketplace", label: "Marketplace" },
  { to: "/admin/margin", label: "Margin (internal)" },
  { to: "/campaigns", label: "Campaigns" },
  { to: "/employees", label: "Employees" },
  { to: "/csv-upload", label: "CSV Upload" },
  { to: "/email-intake", label: "Email Intake" },
  { to: "/delivery", label: "Delivery Destinations" },
  { to: "/delivery-health", label: "Delivery Health" },
  { to: "/admin/failed-deliveries", label: "Failed Deliveries" },
  { to: "/admin/prospect-engagement", label: "Prospect Engagement" },
  { to: "/invoices", label: "Invoices" },
  { to: "/integrations", label: "Integrations" },
  { to: "/form-integrations", label: "Form Adapters" },
  { to: "/quality-alerts", label: "Quality Alerts" },
  { to: "/scheduled-reports", label: "Scheduled Reports" },
  { to: "/audit", label: "Audit Log" },
  { to: "/mfa-policies", label: "MFA Policies" },
  { to: "/settings/platform", label: "Platform Settings" },
  { to: "/admin/menu", label: "Menu Settings" },
  { to: "/admin/code-health", label: "Code Health" },
  { to: "/admin/affiliate-quality", label: "Affiliate Quality" },
  { to: "/admin/buyer-rejections", label: "Buyer Rejections" },
  { to: "/admin/paused-traffic", label: "Paused Traffic" },
  { to: "/timeline", label: "Activity" },
  { to: "/help", label: "Guide" },
];

export const MEDIA_BUYER_MENU = [
  { to: "/admin/landing-pages", label: "Landing Pages" },
  { to: "/admin/pixels", label: "Marketing Pixels" },
  { to: "/media-buyer/custom-tracking", label: "Custom Tracking" },
  { to: "/postbacks", label: "Postbacks" },
  { to: "/media-buyer/attribution", label: "Attribution" },
  { to: "/results", label: "Traffic Results" },
  { to: "/timeline", label: "Activity" },
  { to: "/help", label: "Help" },
];

export const menuFor = (role) => (role === "media_buyer" ? MEDIA_BUYER_MENU : MAIN_MENU);

export const defaultOrder = (role) => Object.fromEntries(menuFor(role).map((m, i) => [m.to, (i + 1) * 10]));

// Locked items super admins can't hide (so they can always get back to the menu settings).
export const LOCKED = { super_admin: ["/admin/menu", "/settings/platform"] };
